<template>
  <v-container>
    <p class="font-weight-black display-4">Playlist</p>
    <p class="font-weight-regular title">Play from this list to get some of the best curated album art to save as your Diffuse default palette.</p>
    <v-divider></v-divider>
    <a class="pa-2" href="https://open.spotify.com/playlist/4UheARoqieLM2Hf5ke8SFK?si=7fa26284ac924bc5" target="_blank">
      <v-img contain :src="require('../assets/logos/spotify.png')" max-height="100"/>
    </a>
    <v-divider></v-divider>
    <a class="pa-2" href="https://music.youtube.com/playlist?list=PLEZwEDULnyudy_-OCYHLvoHcVGuoM4B6m&feature=share" target="_blank">
      <v-img contain :src="require('../assets/logos/youtube.png')" max-height="70"/>
    </a>
    <v-divider></v-divider>
    <a class="pa-2" href="https://soundcloud.com/justzht/sets/diffuse" target="_blank">
      <v-img contain :src="require('../assets/logos/soundcloud.png')" max-height="120"/>
    </a>
    <v-divider></v-divider>
    <p class="py-6 font-weight-regular text-center">MORE TO COME</p>
  </v-container>
</template>

<script>
export default {
  name: "Playlist"
}
</script>

<style scoped>

</style>